import { PanelsApi } from './PanelsApi';
import { MasterStructureFetcher } from '../utils/masterStructureFetcher';
import { getFedopsLogger } from './services/getFedopsLogger';
import { AddElementsApi } from './services/AddElementsPanelApi';
import { getExperiments } from './services/getExperiments';
import { AppDescriptorApiFactory } from '../editor';
export class PanelsApiFactory {
    async createPanelsApi(editorSdkOrOptions) {
        const { editorSDK, editorType, essentials } = editorSdkOrOptions;
        const [experiments, fedopsLogger] = await Promise.all([
            getExperiments(essentials),
            getFedopsLogger(editorSDK, essentials),
        ]);
        const appDescriptorApi = editorSdkOrOptions.usePlatformizedAppDescriptor
            ? await new AppDescriptorApiFactory().createAppDescriptorApi({
                essentials,
            })
            : undefined;
        const customPanelApi = new PanelsApi(editorSDK, editorType, fedopsLogger, experiments, essentials.httpClient, appDescriptorApi);
        await customPanelApi.initialize();
        const masterStructureFetcher = new MasterStructureFetcher(editorSDK);
        const appElementsPanelApi = new AddElementsApi(editorSDK, masterStructureFetcher);
        return {
            openAddElementsPanel: appElementsPanelApi.openAddElementsPanel,
            openBlocksPanel: customPanelApi.openBlocksPanel,
            openDashboardPanel: customPanelApi.openDashboardPanel,
        };
    }
}
//# sourceMappingURL=PanelsApiFactory.js.map